import React, { ReactElement } from 'react';

export const TipContent = (isFolder: boolean): ReactElement => (
    <div>
        <span>Одиночный клик выделяет {isFolder ? 'папку' : 'файл'}.</span>
        <br />
        <span>Для {isFolder ? 'её' : 'его'} открытия сделайте двойной клик.</span>
    </div>
);
